var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3631 20.7609C34.2946 20.7609 30.1858 24.8974 30.1858 30C30.1858 35.1026 34.2946 39.2391 39.3631 39.2391C44.4316 39.2391 48.5404 35.1026 48.5404 30C48.5404 24.8974 44.4316 20.7609 39.3631 20.7609ZM26.9467 30C26.9467 23.0964 32.5057 17.5 39.3631 17.5C46.2205 17.5 51.7795 23.0964 51.7795 30C51.7795 36.9036 46.2205 42.5 39.3631 42.5C32.5057 42.5 26.9467 36.9036 26.9467 30Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1395 48.0882C28.3245 48.0882 21.7033 54.1224 21.7033 60.9559C21.7033 61.8087 21.0422 62.5 20.2267 62.5C19.4111 62.5 18.75 61.8087 18.75 60.9559C18.75 51.8541 27.2894 45 37.1395 45C37.9551 45 38.6162 45.6913 38.6162 46.5441C38.6162 47.3969 37.9551 48.0882 37.1395 48.0882Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.79 47.8466C48.9769 47.8466 46.6964 50.1424 46.6964 52.9745C46.6964 55.8066 48.9769 58.1024 51.79 58.1024C54.6031 58.1024 56.8837 55.8066 56.8837 52.9745C56.8837 50.1424 54.6031 47.8466 51.79 47.8466ZM43.5779 52.9745C43.5779 48.4085 47.2546 44.707 51.79 44.707C56.3255 44.707 60.0022 48.4085 60.0022 52.9745C60.0022 57.5405 56.3255 61.242 51.79 61.242C47.2546 61.242 43.5779 57.5405 43.5779 52.9745Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5091 57.7254C57.118 57.1124 58.1053 57.1124 58.7142 57.7254L60.7933 59.8184C61.4022 60.4315 61.4022 61.4254 60.7933 62.0384C60.1843 62.6514 59.197 62.6514 58.5881 62.0384L56.5091 59.9454C55.9002 59.3324 55.9002 58.3384 56.5091 57.7254Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialProfile);
export default __webpack_public_path__ + "static/media/social-profile.4287af87.svg";
export { ForwardRef as ReactComponent };